export const experience = {

  title: "Experience",
  subtitle: "Work, Internships and Activities",

  description: `💼 Looking out for Software Development roles`,
  description1: "💻 Open to work on freelancing Projects.",

  currentCompanyName: "Cerebranium.",
  currentCompanyWebsiteLink: "https://www.myracle.io/",

  sections: [
    {
      title: "Work Experience",
      isExpanded: true,
      experiences: [

        {
          title: "Software Engineer Intern",
          company: "FINRA",
          company_url: "https://www.finra.org/",
          logo_path: "finra.png",
          duration: "May 2024 - Aug 2024",
          description: [
             
            {
              icon: `⌨️`,
              text: `Delivered secure, automated solutions for the Chief Legal Office at FINRA, enhancing compliance workflows and operational efficiency for a regulatory
 body overseeing 3,400+ firms and 630,000+ brokers.`
            },
            {
              icon: `👨‍💼`,
              text: `Architected ServiceNow integration with AWS, Python, and JavaScript, automating workflows to cut manual effort by 15 hours/week and reduce data
 inconsistencies by 10%, enhancing CLO compliance efficiency.`
            },
            {
              icon: `🖥️`,
              text: `Engineered a Python-based automated secret key retrieval system, eliminating manual rotation, achieving 100% error reduction, and strengthening security
 for FINRA’s critical systems`
            },
            {
              icon: `✨`,
              text: `Tech Stack : ServiceNow, Python, JavaScript, AWS, Git, Agile, CI/CD, Jenkins.`
            }
          ],
        },


        {
          title: "Founding Engineer",
          company: "BillingFast",
          company_url: "https://www.billingfast.com/",
          logo_path: "billingFastLogo.png",
          duration: "Dec 2022 - Sept 2023",
          description: [
            {
              icon: `📱`,
              text : ` Built and scaled a global inventory and billing platform adopted by 35,000+ businesses, leading development of a scalable cross-platform solution with
 Flutter and React, and building backend services with Typescript and Python, on GCP to support a 3M+ SKU FMCG database with high performance and
 seamless integration.`
            },
            {
              icon: `☁️`,
              text: `Engineered a custom-domain web-store hosting platform on Google Cloud by architecting Compute Engine managed instance groups with autoscaling,
 HTTP(S) load balancing with SSL termination, enabling retailers to deploy global branded e-commerce sites and drive 30% sales uplift.`
            },
           
            {
              icon: `📈`,
              text: ` Implemented high-availability APIs in Python & TypeScript using GCP Cloud Functions following Clean Architecture principles and RESTful best
 practices, improving response times to ensure sub-300ms latency under peak loads.`
            },
            {
              icon: `✨`,
              text: `Tech Stack : Flutter, Git, Typescript, Python, Node JS, Android, GCP`
            }

          ],
        },

        {
          title: "Founding Engineer",
          company: "Cerebranium",
          company_url: "https://www.myracle.io/",
          logo_path: "myracleLogo.webp",
          duration: "May 2020 - Sept 2022",
          description: [

            {
              icon: `⌨️`,
              text:` Led a team of 5 as a founding engineer to architect and ship cross-platform XR ed-tech apps, leveraging Flutter, Unity3D, TypeScript, Python, and GCP,
 delivering immersive AR/VR science labs and AI-enabled remote proctoring to thousands of schools and students.`
            },
            {
              icon: `👨‍💼`,
              text: ` Migrated database from Firebase (NoSQL) to Google Spanner, leading redesign of schemas and data pipelines to reduce costs by 10% and accelerate query
 performance by 20%`
            },
            {
              icon: `📂`,
              text: ` Set up Agile development as Scrum Master, driving 90% sprint deadline adherence and meeting 95% of sprint goals, increasing team velocity and delivery
 consistency.`
            },

            {
              icon: `📌`,
              text: ` Built data analytics and CI/CD infrastructure, utilizing BigQuery + Looker Studio for visualizing 10K+ daily assessments and automating mobile build
 pipelines via GitHub Actions (cutting deployment time by 30%), while implementing Sentry error monitoring to raise app stability to 90%.`
            },

            {
              icon: `🖥️`,
              text : `Collaborated with ML team to deploy AI-powered proctoring, orchestrating CV pipelines capable of processing 10K+ exam videos daily with real-time
 detection and integrity reporting.`
            },

            {
              icon: `✨`,
              text: `Tech Stack : Flutter, Android, Git, TypeScript, JavaScript, Python, Error monitoring (Sentry), GCP.`
            }


          ],
        },



      ],
    },


    {
      title: "Internships",
      isExpanded: false,

      experiences: [

        {
          title: "Mobile Engineer Intern",
          company: "Cerebranium",
          company_url: "https://cerebranium.com/",
          logo_path: "cerebraniumLogo.png",
          duration: "July 2020 - Nov 2020",
          description: [

            {
              icon: `📱`,
              text: `Built cross platform scalable mobile applications using Flutter and Google cloud platforms for an edtech product product.`,
            },

            {
              icon: `⚙️`,
              text: `Researched about Software architecture concepts and design patterns like Clean Architecture to maintain the code base effeciently.`
            },
            {
              icon: `✨`,
              text: `Tech Stack : Git, Flutter, Android. `
            }
          ],
        },
        {
          title: "Java Software Developer Intern",
          company: "Godrej InfoTech",
          company_url: "https://www.godrejinfotech.com/",
          logo_path: "godrejInfoTechLogo.svg",
          duration: "June 2019 - July 2019",
          description: [

            {
              icon: `🌐`,
              text: ` Collaborated with ML team to deploy AI-powered proctoring, orchestrating CV pipelines capable of processing 10K+ exam videos daily with real-time
 detection and integrity reporting.`
            },

            {
              icon: `✨`,
              text: `Tech Stack : Java Spring Boot. `
            }

          ],
        },

      ],
    },

    {
      title: "Activities",
      experiences: [

        // {
        //   title: "Smart India Hackathon",
        //   company: "",
        //   company_url: "https://www.sih.gov.in/sih2019",
        //   logo_path: "SIH.png",
        //   duration: "Mar 2019",
        //   description: [

        //     {
        //       icon: `💻`,
        //       text: `Represented our college in a 36 hour national level hackathon conducted at Sathyabama University, Chennai where our team came up with a solution to present obstacles around an aerodome.`,
        //     },

        //   ],
        // },



        // {
        //   title: "Aavhan IIT Bombay Sports Fest",
        //   company: "",
        //   company_url: "https://aavhan.org/#/",
        //   logo_path: "aavhan.png",
        //   duration: "Aug 2023",
        //   description: [

        //     {
        //       icon: `🏋️‍♂️`,
        //       text: `Won 3rd place for weightlifting (under 80kg category) held at IIT Bombay, Mumbai.
        //       `,
        //     },

        //   ],
        // },



      ],
    },
  ],

}
